import { Box, Heading, Stack } from 'braid-design-system';
import type { ComponentProps, ReactElement, ReactNode } from 'react';

import * as styles from './PageTitle.css';

export const PageTitle = ({
  children,
  icon,
  subHeading,
  htmlTitle,
}: {
  children?: ReactNode;
  icon?: ComponentProps<typeof Heading>['icon'];
  subHeading?: ReactElement;
  htmlTitle?: string;
}) => (
  <Heading component="h1" icon={icon} level="2">
    <Stack space="small">
      <Box className={styles.header} title={htmlTitle}>
        {children}
      </Box>

      {subHeading}
    </Stack>
  </Heading>
);
